export default function ProfileImage({ src, alt = "پروفایل", size = "w-28 h-28" }) {
  return (
    <div className="flex-shrink-0">
      <img
        src={src || "/images/default-avatar.png"}
        alt={alt}
        className={`${size} rounded-full object-cover border-4 border-blue-100 shadow-sm`}
      />
    </div>
  );
}
